/*
 * @Author: Teemo Ding
 * @Date: 2021-10-21 15:13:33
 * @LastEditTime: 2021-12-30 13:57:25
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/miniProgramSetting.ts
 */
import { post, get } from 'src/tools/server';

// // 绑定微信
// export const request_bind = (salesChannelUuid: string) => {
//   return get<any>(
//     `/portal/salesChannelSetting/miniProgramSetting/authorize/${salesChannelUuid}`,
//     {},
//   );
// };

// 解绑微信
export const request_unBind = (miniProgramUuid) => {
  return get<any>(
    `/portal​/salesChannelSetting​/miniProgramSetting​/unAuthorize​/${miniProgramUuid}`,
    {},
  );
};

//初始化
export const request_landingPage = (salesChannelUuid: string) => {
  return get<any>(
    `/portal/salesChannelSetting/miniProgramSetting/landingPage/${salesChannelUuid}`,
    {},
  );
};

export const request_uploadCodeVersion = (data) => {
  return post<any>(
    `/portal/salesChannelSetting/miniProgramSetting/preview`,
    data || {},
    {
      returnWholeData: true,
      handleErrorAsResolve: true,
    },
  );
};

export const request_generateQrCode = (miniProgramVersionUuid) => {
  return get<any>(
    `/portal/salesChannelSetting/miniProgramSetting/generateQrCode/${miniProgramVersionUuid}`,
    {
      returnWholeData: true,
    },
  );
};

export const request_generateAuthUrl = (salesChannelUuid) => {
  return get<any>(
    `/portal/salesChannelSetting/miniProgramSetting/authorizeUrl/${salesChannelUuid}`,
    {
      returnWholeData: true,
    },
  );
};

export const request_review = (miniProgramVersionUuid) => {
  return post<any>(
    `/portal/salesChannelSetting/miniProgramSetting/review/${miniProgramVersionUuid}`,
    {},
    {},
  );
};

export const request_release = (miniProgramVersionUuid) => {
  return post<any>(
    `/portal/salesChannelSetting/miniProgramSetting/release/${miniProgramVersionUuid}`,
    {},
    {},
  );
};

export const request_authorizeCallback = (uuid, data) => {
  return get<any>(
    `/portal/salesChannelSetting/miniProgramSetting/authorize/${uuid}`,
    {
      params: data,
      returnWholeData: true,
      handleErrorAsResolve: true,
    },
  );
};

export const request_unAuthorizeCallback = (miniProgramUuid) => {
  return get<any>(
    `/portal/salesChannelSetting/miniProgramSetting/unAuthorize/${miniProgramUuid}`,
    {
      returnWholeData: true,
      handleErrorAsResolve: true,
    },
  );
};
export const request_update = (data) => {
  return post<any>(
    `/portal/salesChannelSetting/miniProgramSetting/update`,
    data,
    {},
  );
};

export const getDownloadAccess = (miniProgramUuid: string) => {
  return get<any>(
    `/portal/salesChannelSetting/miniProgramSetting/getWebViewDomainConfirmFile/${miniProgramUuid}`,
    {
      returnWholeData: true,
      responseType: 'arraybuffer',
    },
  );
};

export const updateDomain = (body) => {
  return post<any>(
    `/portal/salesChannelSetting/miniProgramSetting/setWebViewDomainDirectly`,
    body,
    {},
  );
};
//import { convertRes2Blob } from 'src/tools/helper';
